import {
  makeDateFilter,
  makeKeywordFilter,
  makeMediaTypeFilter,
  makePageSizeFilter,
} from '../integrationlayer/SearchParameter';

export class PlayAudioClient {
  constructor(config) {
    this.config = config;
  }

  search(searchRequest) {
    const pageSizeFilter = makePageSizeFilter(
      this.config.hitsPerPage * (searchRequest.page * 1 + 1),
    );

    const allParams = []
      .concat(pageSizeFilter)
      .concat(makeKeywordFilter(searchRequest.q))
      .concat(makeDateFilter(searchRequest))
      .concat(makeMediaTypeFilter(this.config.mediaType));

    const url = new URL(this.config.host + this.config.endpointMedia);
    allParams.forEach((entry) =>
      url.searchParams.set(entry.param, entry.value),
    );

    return window.fetch(url.toString()).then((res) => res.json());
  }

  searchRadioShows(searchRequest) {
    const allParams = []
      .concat(makePageSizeFilter(16))
      .concat(makeKeywordFilter(searchRequest.q));

    const url = new URL(this.config.host + this.config.endpointShow);
    allParams.forEach((entry) =>
      url.searchParams.set(entry.param, entry.value),
    );

    return window.fetch(url.toString()).then((res) => res.json());
  }
}

export default PlayAudioClient;
